/**
 * True while an input method editor (Japanese, Chinese, Korean, ...) owns the keystroke. IME users press Enter to
 * confirm characters, Escape to cancel a conversion and arrows to move through candidates, so handlers for those keys
 * must leave them alone. keyCode 229 covers Safari, which fires the confirming keydown after compositionend, when
 * isComposing is already false.
 */
export function isImeComposing(event: KeyboardEvent): boolean {
    return event.isComposing || event.keyCode === 229;
}

/** Wraps a submit-on-key handler so a key that belongs to an active IME composition neither submits nor is prevented. */
export function unlessComposing(action: () => void): (event: KeyboardEvent) => void {
    return (event) => {
        if (isImeComposing(event)) {
            return;
        }
        event.preventDefault();
        action();
    };
}
